export enum jobStatus {
    RUNNING = "RUNNING",
    FINISHED = "FINISHED",
    ERROR = "ERROR"
}

export enum eventStatus {
    PRE_EVENT = "Pre-Event",
    LIVE = "Live",
    SOLD_OUT = "Sold Out",
    CLOSED = "Closed",
    ARCHIVED = "Archived",
    COMPLETED = "Completed",
    ON_SITE = "On-Site"
}

export enum eventType {
    ONLINE = "ONLINE",
    OFFLINE = "OFFLINE"
}

// placed here because is related to event resource
export interface IAttendeeCategory {
    id: number;
    name: string;
    count?: number;
}

export interface IAttendeeCountCategory {
    category: IAttendeeCategory,
    numAttendees?: number
}

export interface IAddAttendeeCategory {
    thirdPartyId?: string;
    name: string;
    parentThirdPartyId?: string;
}

export default interface IEvent {
    id: number,
    name: string,
    city: string,
    locationName: string,
    description: string,
    archived: boolean,
    archivingPeriod: string,
    createdAt: Date,
    deleted: boolean,
    startDateTime: Date,
    endDateTime: Date,
    autoSync: boolean,
    logoUrl: string,
    status: eventStatus,
    thirdPartyId: string,
    timeZone: string,
    group?: string,
    modifiedAt: Date,
    modifiedOn: Date,
    type: eventType,
    registeredAttendeesCount: number,
    arrivedAttendeesCount: number
    hasFraudDetection?: boolean;
}

export interface IFdListHeaderAction {
    label: string;
    key: string;
    callback: Function;
    position: "LEFT" | "RIGHT"; // Display placement of buttons in header(left or right)
    forceEnable?: Boolean; // the button will be enable(active) to perform action
    alertMessage?: string;
    startIcon: React.ReactNode,
    isEnabled?:boolean;
}

export interface IButtonActions {
    label?: string | React.ReactNode;
    type?: string;
    callback?: Function;
    icon?: React.ReactNode,
}